/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class FxRateDialog extends SiteEntityDialog<FxRateRow, any> {
        protected getFormKey() { return FxRateForm.formKey; }
        protected getIdProperty() { return FxRateRow.idProperty; }
        protected getLocalTextPrefix() { return FxRateRow.localTextPrefix; }
        protected getNameProperty() { return FxRateRow.nameProperty; }
        protected getService() { return FxRateService.baseUrl; }

        protected form = new FxRateForm(this.idPrefix);

    }
}